import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toastManager from '@/lib/toast/toastManager.js';
import Composer from '../components/Composer.jsx';
import ConversationList from '../components/ConversationList.jsx';
import SuggestionList from '../components/SuggestionList.jsx';
import startAssistantRequest from '../lib/startAssistantRequest.js';

/** The assistant's start: write a request (or pick a suggestion), and find every earlier conversation. */
const HomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isStarting, setIsStarting] = useState(false);

  const start = async ({ prompt, attachments = [] }) => {
    setIsStarting(true);
    const res = await dispatch(startAssistantRequest({ prompt, attachments }));
    setIsStarting(false);
    if (!res.success) {
      toastManager.add({ title: 'Request not sent', description: res.message, type: 'error' });
      return res;
    }
    navigate(`/threads/${res.threadId}`);
    return res;
  };

  return (
    <div className="assistant-home">
      <header className="assistant-home__intro">
        <h1 className="assistant-home__title">What should Pieve take care of?</h1>
        <p className="assistant-home__lead">Describe the outcome. Pieve works in your connected apps, shows every step, and asks before it changes anything.</p>
      </header>
      <Composer variant="home" placeholder="For example: find last month's unpaid invoices and remind each customer" onSubmit={start} />
      <SuggestionList disabled={isStarting} onChoose={(prompt) => start({ prompt })} />
      <ConversationList />
    </div>
  );
};

export default HomePage;
